import React from 'react';
import { useTranslation } from 'react-i18next';
import VTSelectDeparture from "../VTSelectDeparture/VTSelectDeparture";
import VTMeetingPoint from "../VTMeetingPoint/VTMeetingPoint";
import VTEspecialExcursion from "../VTEspecialExcursion/VTEspecialExcursion";
import EmdbButtom from "../../../EmdbButtom";

//CSS
import styles from "./VTSummary.module.less";

function Prices({price, bookedPax ,i18n}) {

  if (bookedPax[price.id] > 0)
    return (
      <div className={styles.price}>
        <div className={styles.name}>{price.name[i18n.language] ? price.name[i18n.language]:price.name['es']} {bookedPax[price.id]} x {price.price} &euro;</div>
        <div className={styles.total}>
          {bookedPax[price.id] * price.price} &euro;
        </div>
      </div>
    );
  else return null;
}

function VTSummary({show, excursionInfo, selectedDate, excursionsPrices, bookedPax, availability, getTotalPax, selectedDeparture, specialExcursion, setSpecialExcursion, hotelID, setHotelID, setDeparture, add2cart, debug}) {
  const {t,i18n} = useTranslation("vtform");

  function getTotal(){
    let total=0;
    //Comprobamos primero que existen los objetos necesarios
    if (bookedPax !== null && excursionsPrices !== null){
      for (const idprice in bookedPax){
         total+=bookedPax[idprice] * excursionsPrices[idprice]['price'];
      }
    }
    return total;
  }

  let listPrices = null;
  if (excursionsPrices != null){
    listPrices = Object.keys(excursionsPrices).map(idprice =>{
      return <Prices key={excursionsPrices[idprice].id} price={excursionsPrices[idprice]} bookedPax={bookedPax} i18n={i18n}/>;
    });
  }

  let disableButton=selectedDeparture ? false : true;
  if (excursionInfo != null){
    if (excursionInfo.type < 22) disableButton = !disableButton && hotelID ? false : true;
    if (excursionInfo.isSpecialExcursion) disableButton = !disableButton && specialExcursion ? false : true;
  }

  if (!show) return null;
  else{
    return (
      <div className={styles.vtsummary}>
        <div className={styles.title}>{excursionInfo.name[i18n.language]}</div>

        <VTSelectDeparture
          departures={excursionInfo.departures}
          selectedDate={selectedDate}
          selectedDeparture={selectedDeparture}
          availability={availability}
          getTotalPax={getTotalPax}
          setDeparture={setDeparture}
        />

        <VTEspecialExcursion
          excursionInfo={excursionInfo}
          selectedDate={selectedDate}
          excursionsPrices={excursionsPrices}
          getTotalPax={getTotalPax}
          specialExcursion={specialExcursion}
          setSpecialExcursion={setSpecialExcursion}
          debug={debug}
        />

        <div className={styles.summary}>
          <div className={styles.conditions}>{t('vtsummary.Precio total')}</div>
          <div className={styles.prices}>
            <div className={styles.pricestitle}>{t('vtsummary.Resumen')}</div>
            {listPrices}
          </div>
        </div>

        {excursionInfo.type < 22 &&
          <VTMeetingPoint
            selectedDeparture={selectedDeparture}
            hotelID={hotelID}
            setHotelID={setHotelID}
          />
        }

        <div className={styles.footer}>
          <div className={styles.totalcontainer}>
            <div className={styles.ttt}>{t('vtsummary.Precio total')}</div>
            <div className={styles.total}>{getTotal()} &euro;</div>
            <div className={styles.tax}>{t('vtsummary.Todos los impuestos incluidos')}</div>
          </div>
          <div className={styles.buttons}>
            <EmdbButtom className={styles.button} label={t("vtsummary.Añadir al carro")} onClick={add2cart} disabled={disableButton} />
          </div>
        </div>
      </div>
    );
  }

}

export default VTSummary;
